// removed by extract-text-webpack-plugin
module.exports = {"menu":"_2Tds","burger":"_3ywU","top":"_2jK0","mid":"_3hFZ","bot":"_3afm","whiteVariant":"-SRN","open":"_3x9i","menuOpen":"-Zun","blackout":"_1iZ8","menuList":"uQbH","menuListItem":"_2vV2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuBar/BurgerMenu/styles.scss
// module id = 321
// module chunks = 0